
import styled from 'styled-components';
import { SectionWithCtaCardProps } from './query';
import Button_v2 from '@/components/molecules/Button/index';
import CtaCard from '@/components/molecules/CtaCard';
import Text from '@/components/molecules/Text';
import Title_v2 from '@/components/molecules/Title/index';
import devices from '@/utilities/devices';
import { renderUnderline } from '@/utilities/functions';

const CardsContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	width: 100%;

	> div {
		margin: 2rem 1rem 3rem;
	}
	@media screen and (${devices.mobile}) {
		flex-direction: column;
		> div {
			margin: 1rem 0rem;
		}
	}

	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		flex-direction: column;
		justify-content: center;
		align-items: center;
		> div {
			margin: 1rem 0rem;
		}
	}
`;

const SectionWithCtaCard = ({ sectionWithCtaCardData }: { sectionWithCtaCardData: SectionWithCtaCardProps }) => {
	return (
		<>
			<Title_v2
				align={sectionWithCtaCardData.title.alignedAt}
				underlineColor={sectionWithCtaCardData.title.underlineColor}
			>
				{renderUnderline(sectionWithCtaCardData.title.titlePieces)}
			</Title_v2>
			{sectionWithCtaCardData.description && (
				<Text textAlign='center'>
					{sectionWithCtaCardData.description}
				</Text>
			)}
			<CardsContainer>
				{sectionWithCtaCardData.cards.map(
					(card, index) => (
						<CtaCard
							card={card}
							key={index}
						/>
					),
				)}
			</CardsContainer>
			{
				sectionWithCtaCardData.buttons && (
					sectionWithCtaCardData.buttons.map(
						(button, index) => (
							<Button_v2
								gtm_id={button.trackerId}
								href={button.url}
								key={index}
								openOnNewTab={button.newTab}
								text={button.text}
								version={button.variant}
							/>
						),
					)
				)
			}
		</>
	);
};

export default SectionWithCtaCard;
